export const navigatorPanelId = "reader:navigator";
export const inspectorPanelId = "reader:inspector";
